import Vue from 'vue'
import template from './_auth-app-modal.pug'
import QrcodeVue from 'qrcode.vue'
import ProfileService from 'js/services/api/profile'

export default Vue.extend({
  name: 'AuthAppModal',
  template: template(),
  components: { QrcodeVue },
  props: {
    value: Boolean
  },
  data() {
    return {
      code: '',
      uri: '',
      loading: false
    }
  },
  mounted() {
    this.loadQR()
  },
  methods: {
    async loadQR() {
      try {
        const res = await ProfileService.getQrUri()
        this.uri = res.uri
        console.log('QR URI:', this.uri)
      } catch (err) {
        if (this.$notifications) {
          this.$notifications.error(this.$t('profile.auth2faSettings.authenticator.errorLoadQR'))
        } else {
          console.error(this.$t('profile.auth2faSettings.authenticator.errorLoadQR'))
        }
      }
    },

    async verifyCode() {
      if (!this.code) {
        if (this.$notifications) {
          this.$notifications.error(this.$t('profile.auth2faSettings.authenticator.codeRequired'))
        } else {
          console.error(this.$t('profile.auth2faSettings.authenticator.codeRequired'))
        }
        return
      }

      this.loading = true
      try {
        await ProfileService.verify2FA({
          method2faAuth: 'totp',
          twofacode: this.code,
          email: this.$user.email || ''
        })

         await ProfileService.toggle2FA({
                  enableTwoFactor: true,          
                  method2faAuth: 'totp'
                })

        if (this.$notifications) {
          this.$notifications.success(this.$t('profile.auth2faSettings.modals.totp.success'))
        }

        this.$emit('success')
        this.$emit('close')
      } catch (err) {
        if (this.$notifications) {
          this.$notifications.error(this.$t('profile.auth2faSettings.modals.totp.error'))
        } else {
          console.error(this.$t('profile.auth2faSettings.modals.totp.error'))
        }
      } finally {
        this.loading = false
      }
    }
  }
})
